import { heroStats, quickEntries } from "@/mocks/comics";

export default function HeroSection() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20artistic%20abstract%20comic%20style%20background%20of%20layered%20paper%20panels%20with%20bold%20ink%20brush%20strokes%20and%20halftone%20dots%2C%20warm%20crimson%20orange%20and%20deep%20amber%20limited%20palette%2C%20dramatic%20diagonal%20composition%2C%20grainy%20texture%2C%20no%20text%2C%20cinematic%20web%20hero%20banner&width=1920&height=1080&seq=xx-hero-bg&orientation=landscape"
          alt=""
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/60 to-foreground-950/80"></div>
      </div>

      <div className="relative w-full px-4 pb-14 pt-32 md:px-6 md:pb-20 md:pt-40 lg:px-8">
        <div className="mx-auto w-full max-w-[1120px]">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1 text-xs text-background-100 backdrop-blur">
            <i className="ri-scan-line text-sm text-accent-300" aria-hidden="true"></i>
            收录 3,860 部 · 每日整理更新与完结全集
          </span>

          <h1 className="mt-5 max-w-[880px] font-heading text-3xl leading-tight text-background-50 md:text-5xl">
            香香漫画 · 免费阅读与全集下载，一处跟进最新更新
          </h1>

          <p className="mt-4 max-w-[720px] text-sm leading-relaxed text-background-100 md:text-base">
            这里把「正在连载」和「已经完结」分开整理：想看新话，就看更新速递；想一口气读完，就进完结专区拿全集打包。
            <strong className="font-semibold text-background-50">按状态筛选、按题材浏览、按热度排序</strong>
            ，不用反复翻找章节，也不会错过任何一次更新。
          </p>

          <div className="mt-7 flex flex-wrap gap-2.5">
            {quickEntries.map((entry) => (
              <a
                key={entry.target}
                href={`#${entry.target}`}
                className={`inline-flex items-center gap-2 rounded-md px-4 py-2.5 text-sm font-medium transition-colors whitespace-nowrap ${
                  entry.target === "latest"
                    ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                    : "border border-background-50/30 bg-background-50/10 text-background-50 backdrop-blur hover:bg-background-50/20"
                }`}
              >
                <i className={`${entry.icon} text-base`} aria-hidden="true"></i>
                {entry.label}
              </a>
            ))}
          </div>

          <dl className="mt-10 grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-background-50/15 bg-background-50/10 backdrop-blur lg:grid-cols-4">
            {heroStats.map((stat) => (
              <div key={stat.label} className="flex items-center gap-3 bg-foreground-950/20 px-4 py-4 md:px-5">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-500/20 text-accent-300">
                  <i className={`${stat.icon} text-lg`} aria-hidden="true"></i>
                </span>
                <div>
                  <dt className="text-xs text-background-100/80">{stat.label}</dt>
                  <dd className="font-heading text-lg text-background-50">{stat.value}</dd>
                </div>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}